import React from "react";
import { Route, Routes } from "react-router-dom";
import HomePage from "./FrontPage";
import SearchResultsPage from "./SearchResultsPage";
import SearchRedirectPage from "./SearchRedirectPage";
import CheckoutPage from "./CheckoutPage";
import PageNotFound from "./PageNotFound";
import { ConfirmationPage } from "./ConfirmationPage";
import LowPriceCalendarPage from "./LowPriceCalendar";

const routesArr = [
  { path: "/", element: <HomePage /> },
  { path: "/search-results", element: <SearchResultsPage /> },
  { path: "/search-redirect", element: <SearchRedirectPage /> },
  { path: "/checkout", element: <CheckoutPage /> },
  { path: "/confirmation", element: <ConfirmationPage /> },
  { path: "/calendar", element: <LowPriceCalendarPage /> },

  { path: "*", element: <PageNotFound /> },
];

export const Routings = () => {
  return (
    <Routes>
      {routesArr.map((elm: any, i: number) => {
        return <Route path={elm.path} element={elm.element} key={i} />;
      })}
    </Routes>
  );
};
